import { useContext, useEffect, useMemo, useState } from 'react'

import { SocketContext } from '../../../context/SocketContext'

import { SelectElement } from '../../../components/selectElement2'
import LoadingOverlay from '../../../components/LoadingOverlay';
import { serverApi } from '../../../api';
import { getUsuarioStorage } from '../../../helpers/getUsuarioStorage';


export const UsuariosRoles = () => {

    const { socket } = useContext(SocketContext);
    const usuario = useMemo(() => getUsuarioStorage(), []);

    const [isLoading, setIsLoading] = useState(false);
    const [usuarios, setUsuarios] = useState([]);

    const [query, setQuery] = useState({
        search: '',
        page: 1,
        limit: 10,
        sortBy: 'eol',
        sortDir: 'asc',
        ubicacion: '',
        codigoUbicacion: '',
        uidUsuario: ''
    });

    // tabla
    const [data, setData] = useState([]);
    // const [total, setTotal] = useState(0);
    // const totalPages = Math.ceil(total / query.limit);

    // const [searchInput, setSearchInput] = useState('');

    //Select Usuarios
    useEffect(() => {

        const codigoEntidad = localStorage.getItem("codigoEntidad");
        if (!codigoEntidad) return;

        const fetch = async () => {
            try {

                const resp = await serverApi.post(`/usuarios/select-usuarios`, { codigoEntidad });
                console.log(resp.data);

                const opciones = resp.data.data.map((item) => ({ value: item.uidUsuario, label: item.nombreCompleto.toUpperCase() }))
                setUsuarios(opciones);


            } catch (error) {
                console.error("Error al obtener los usuarios", error);
            } finally {

            }
        };

        fetch();

    }, [])


    useEffect(() => {

        if (!socket) return;

        const handler = (lista) => {
            setData(lista);
        };

        socket.on('lista-usuario-roles', handler);

        return () => {
            socket.off('lista-usuario-roles', handler);
        };



    }, [socket]);

    useEffect(() => {

        const codigoEntidad = usuario.codigoEntidad
        // const codigoUbicacion = usuario.codigoUbicacion

        if (!codigoEntidad) return;

        const load = async () => {
            try {

                setIsLoading(true);

                const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;


                const resp = await serverApi.post(
                    `/usuarios/usuario-roles`,
                    {
                        ...query,
                        codigoEntidad,
                        codigoUbicacion
                    }
                );

                console.log(resp);


                setData(resp.data.data || []);
                // setTotal(resp.data.total || 0);

            } catch (error) {
                console.error("Error al obtener tipos de atención", error);
            } finally {
                setIsLoading(false);
            }
        };

        load();

    }, [query, usuario.codigoUbicacion, usuario.codigoEntidad]);


    const handleChecked = async (seleccion) => {

        const uidRol = seleccion.target.id;
        const checked = seleccion.target.checked;
        if (query.uidUsuario === "") return;

        try {

            setIsLoading(true);

            const codigoEntidad = usuario.codigoEntidad;
            if (codigoEntidad === "") return;
            const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
            console.log(query);

            await serverApi.post(
                `/usuarios/edita-usuario-rol`,
                {
                    ...query,
                    codigoEntidad,
                    codigoUbicacion,
                    uidRol,
                    checked
                }
            );

        } catch (error) {
            console.error("Error al obtener tipos de atención", error);
        } finally {
            setIsLoading(false);
        }


    }

    const handleSelectUsuario = (selected) => {
        setQuery(prev => ({
            ...prev,
            uidUsuario: selected.value,
        }));
    };

    return (
        <>
            {isLoading && <LoadingOverlay />}

            <div className={`content ${isLoading ? 'opacity' : ''} m-5`}>

                <div className='row'>
                    <div className='form-group col-lg-4 col-12'>

                        <label> Usuarios </label>
                        <SelectElement
                            options={usuarios}
                            name={"uidUsuario"}
                            isMulti={false}
                            closeOnMenuSelect={true}
                            value={usuarios.find(u => u.value === query.uidUsuario)}
                            onChange={(selected) => handleSelectUsuario(selected)}
                            classname="form-control form-control-lg"
                            isClearable={false}
                        />
                    </div>

                    <div className='form-group col-lg-8 col-12 rounded shadow p-3'>


                        <div className='col-12 '>
                            <table className='table table-responsive table-striped max600' width={'100%'}  >
                                <thead>
                                    <tr>
                                        <th width={'5%'}></th>
                                        <th width={'95%'}>Roles</th>
                                    </tr>
                                </thead>
                                <tbody width={'100%'} >
                                    {data.map((item, i) => (

                                        <tr key={item.uidRol}>
                                            <td width={'5%'}>

                                                <div className="form-check form-switch">
                                                    {/* { console.log(typeof(item.uidModulo), typeof(moduloSeleccionado) ) } */}
                                                    <input
                                                        className="form-check-input"
                                                        checked={item.checked}
                                                        type="checkbox"
                                                        id={`${item.uidRol}`}
                                                        onChange={(seleccion) => handleChecked(seleccion)}



                                                    />

                                                    <label className="form-check-label" htmlFor="chkAsignado_"></label>
                                                </div>


                                            </td>
                                            <td width={'95%'}>
                                                {item.rol.toUpperCase()}
                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>



                    </div>


                </div>

            </div>
        </>


    )
}
